import type * as React from 'react';
import { get } from '@Domain/Api';
import templateFieldTypesFetched, {
	type TemplateFieldTypesFetchedAction,
	type TemplateFieldTypesFetchedPayload,
} from '@Application/Documents/TemplateFieldTypes/Actions/templateFieldTypesFetched';
import templateFieldTypesFetchFailed, {
	type TemplateFieldTypesFetchFailedAction,
} from '@Application/Documents/TemplateFieldTypes/Actions/templateFieldTypesFetchFailed';
import type FetchTemplateFieldTypes from '@Application/Documents/TemplateFieldTypes/Queries/FetchTemplateFieldTypes';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = TemplateFieldTypesFetchedAction | TemplateFieldTypesFetchFailedAction;

export default (_query: FetchTemplateFieldTypes) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<TemplateFieldTypesFetchedPayload>(
				`${parameters.api.host}/api/enums/template-field-types`,
			);

			const action = templateFieldTypesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = templateFieldTypesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
